import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { SHELL } from "../../constants/testIds";
import { InitialsAvatar } from "../shared/InitialsAvatar";
import {
    LayoutDashboard, Users, Building2, MapPin, ClipboardList,
    CalendarRange, LogOut, CheckSquare, BarChart3, Settings as SettingsIcon,
} from "lucide-react";

const links = [
    { to: "/admin", label: "Dashboard", icon: LayoutDashboard, testid: SHELL.linkDashboard, end: true },
    { to: "/admin/users", label: "Users", icon: Users, testid: SHELL.linkUsers },
    { to: "/admin/clients", label: "Clients", icon: Building2, testid: SHELL.linkClients },
    { to: "/admin/jobs", label: "Jobs", icon: MapPin, testid: SHELL.linkJobs },
    { to: "/timesheet", label: "Timesheet", icon: ClipboardList, testid: SHELL.linkTimesheet },
    { to: "/admin/schedule", label: "Schedule", icon: CalendarRange, testid: SHELL.linkSchedule },
    { to: "/admin/approvals", label: "Approvals", icon: CheckSquare, testid: SHELL.linkApprovals },
    { to: "/admin/reports", label: "Reports", icon: BarChart3, testid: SHELL.linkReports },
    { to: "/admin/settings", label: "Settings", icon: SettingsIcon, testid: SHELL.linkSettings },
];

export function Sidebar() {
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    const doLogout = async () => {
        await logout();
        navigate("/login", { replace: true });
    };
    return (
        <aside
            data-testid={SHELL.sidebar}
            className="km-rail w-60 shrink-0 h-screen sticky top-0 flex flex-col"
        >
            <div className="px-4 pt-6 pb-8">
                <div className="inline-flex bg-white rounded-xl px-4 py-3 shadow-sm">
                    <img
                        src="/logo.png"
                        alt="KMSurveys"
                        className="h-9 w-auto"
                        draggable={false}
                    />
                </div>
            </div>
            <nav className="flex-1 px-2">
                {links.map((l) => {
                    const Icon = l.icon;
                    return (
                        <NavLink
                            key={l.to}
                            to={l.to}
                            end={l.end}
                            data-testid={l.testid}
                            className={({ isActive }) =>
                                `flex items-center gap-3 px-4 py-2.5 text-sm rounded-r-md mb-0.5 ${
                                    isActive ? "active-link" : ""
                                }`
                            }
                        >
                            <Icon size={16} strokeWidth={1.6} />
                            <span>{l.label}</span>
                        </NavLink>
                    );
                })}
            </nav>
            <div className="p-3 border-t border-white/5">
                <div data-testid={SHELL.userChip} className="flex items-center gap-3 px-2 py-2">
                    <InitialsAvatar name={user?.name} initials={user?.initials} />
                    <div className="min-w-0 flex-1">
                        <div className="text-sm text-white truncate">{user?.name}</div>
                        <div className="text-[11px] text-[color:#8a94a6] uppercase tracking-wider">
                            {user?.role}
                        </div>
                    </div>
                    <button
                        onClick={doLogout}
                        data-testid={SHELL.logout}
                        className="p-1.5 rounded hover:bg-white/5 text-[color:#a9b2c1] hover:text-white"
                        title="Log out"
                    >
                        <LogOut size={15} />
                    </button>
                </div>
            </div>
        </aside>
    );
}
